<section class="col-12 col-xs-12 col-sm-7 col-md-8 left-section">
  <div class="c-widget c-widget--no-borders d-flex d-sm-none">
    <h3 class="c-widget-title c-heading c-heading-h2">{{ "accountOverview.myAccount_label" | cxTranslate }}</h3>
    <div class="c-widget-divider"></div>
    <div class="d-flex justify-content-between">
      <div class="c-widget--my-account-description">
        {{ "accountOverview.account_label" | cxTranslate }} &nbsp;
        <strong>{{ accountNumber }}</strong>
      </div>
      <div>
        <a
          class="c-link"
          data-di-id="di-id-9b8eeaed-3b366785"
          href="javascript:;"
          (click)="navigateToAccountDetails()"
        >
          {{ "accountOverview.view_label" | cxTranslate }}
        </a>
      </div>
    </div>
  </div>
  <app-order-list></app-order-list>
</section>
